import { render, staticRenderFns } from "./QuestionBox.vue?vue&type=template&id=5e1a8b6c&scoped=true"
import script from "./QuestionBox.vue?vue&type=script&lang=js"
export * from "./QuestionBox.vue?vue&type=script&lang=js"
import style0 from "./QuestionBox.vue?vue&type=style&index=0&id=5e1a8b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a8b6c",
  null
  
)

export default component.exports